import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../i18n/useLanguage";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";

type ProductInfoProps = {
  className?: string;
  part: TirePartItem | null;
};

export const Description: FunctionComponent<ProductInfoProps> = ({
  className,
  part,
}) => {
  const [language] = useLanguage();
  const { t } = useTranslation();

  return (
    <div className={clsx(className, "text-xs")}>
      {part?.partDetails.primaryPart.tireModelDescription[language] ||
        part?.partDetails.primaryPart.tireModelDescription.en ||
        t("compare.notAvailable")}
    </div>
  );
};
